import React from 'react';
import { queries } from '../../../graphql/graphql';
import ListContainer from '../../../components/containers/AdminList';

const ListPlanOwners: React.FC = () => {
  return (
    <ListContainer
      prefix="plan-owner"
      query={queries.planOwners.PLAN_OWNERS}
      inline={true}
      editable={true}
      canCreate={true}
      adminView={true}
    />
  );
};

export default ListPlanOwners;
